import React from 'react'
import NosFormulaires from '../HomePage/NosFormulaires'
import CommentPublier from '../HomePage/CommentPublier'
import ToutSavoir from '../HomePage/ToutSavoir'
import LesFormulaires from '../HomePage/LesFormulaires'
import Actualites from '../HomePage/Actualites'
import Footer from '../../component/Footer' 
export default function Hero() {
    return (
        <>
            
            {/* <div className='bg-thColor' > */}
            <div  >
                <NosFormulaires />
            </div>
            <CommentPublier />
            <ToutSavoir />
            <LesFormulaires />
            <Actualites />
            <Footer />
        </>
    )
}
